export const PDF_PAGE_WIDTH = 700;
